module.exports = __webpack_public_path__ + "static/img/company-info-pc.65e9e8c.png";